import * as React from "react";
import {
    List,
    TextField,
    Edit,
    Create,
    SimpleForm,
    FunctionField,
    SelectInput,
    TextInput,
    required,
    CreateButton,
    FilterButton,
    TopToolbar,
    Show,
    TabbedShowLayout,
    ShowButton,
    ReferenceManyCount,
    useRecordContext,
    ReferenceManyField,
    Datagrid,
    useGetList,
    usePermissions,
    Loading,
    useGetOne,
    PasswordInput,
    useCreate,
    DateField,
    SearchInput
} from 'react-admin';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import EmailIcon from '@mui/icons-material/Email';
import QuizIcon from '@mui/icons-material/Quiz';
import Button from '@mui/material/Button';
import NoteIcon from '@mui/icons-material/Note';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from "@material-ui/core/Typography";
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { EditableDatagrid, RowForm } from "@react-admin/ra-editable-datagrid";
import { iconStyle } from '../shared/Styles/iconsStyles';
import { saveButtonCss, showButtonCss } from '../shared/Styles/buttonStyles';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { fieldTabForShow } from '../shared/Styles/fieldsStyles';
import { createButtonCss, filterButtonCss } from '../shared/Styles/buttonStyles';
import { listCss } from '../shared/Styles/listStyles';
import { ConfirmDialogDeleteButtonCustom } from "../shared/DeleteButtonCustom";
import { ConfirmDialogCreateButtonCustom } from "../shared/CreateButtonCustom";
import { ConfirmDialogSendButtonCustom } from "./SendButtonCustom";
import { CalcolaButtonBox } from "../domande/CalcolaButtonBox";
import GetUltimoCalcolo from "../domande/GetUltimoCalcolo";
import GetUltimoInoltro from "./GetUltimoInoltro";
import { startActionButtonCss } from '../shared/Styles/buttonStyles';
import DialogDataScadenza from "./DialogDataScadenza";
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';

// Impost Custom List Page 
import EmptyListCustom from '../shared/emptyPageCustom/empryPageCustom';
import { Leaderboard } from "@mui/icons-material";
import GetGraficoQuiz from './GetGraficoQuiz';

const ListActions = () => (
    <TopToolbar>

        <CreateButton sx={createButtonCss} />
        <FilterButton sx={filterButtonCss} />

    </TopToolbar>
);


// Validazione
const validateOperatoreCreation = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Il nome è necessario';
    }
    if (!values.cognome) {
        errors.cognome = 'Il cognome è necessario';
    }
    /* if (!values.age) {
        // You can return translation keys
        errors.age = 'ra.validation.required';
    } else if (values.age < 18) {
        // Or an object if the translation messages need parameters
        errors.age = {
            message: 'ra.validation.minValue',
            args: { min: 18 }
        };
    } */
    return errors
};


export const UsersList = props => {

    return (
        <List filters={UsersFilters} perPage={50} actions={<ListActions />} exporter={false} {...props}>
            <EditableDatagrid
                sx={listCss}
                //  noDelete
                editForm={<UsersListForm />}
                bulkActionButtons={false}>
                {<TextField label="User Id" source="id" />}
                {<TextField label="Email" source="email" />}
                {<TextField label="Ruolo" source="roles" />}
                {<DateField label="Data Creazione" source="createdAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}
                {<DateField label="Data Ultima Modifica" source="updatedAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}

                {<ShowButton sx={showButtonCss} label="Dettaglio" />}
            </EditableDatagrid>
        </List>
    );
}

const UsersListForm = (props) => (
    <RowForm {...props}>
        {<TextField label="User Id" source="id" />}
        {<TextInput label="Email" source="email" validate={[required()]} />}
        {<SelectInput label="Ruolo" source="roles" validate={[required()]} choices={[{ id: 'admin', name: 'admin' },
        { id: 'candidato', name: 'candidato' },
        { id: 'collaboratore', name: 'collaboratore' }]} />}
        {<PasswordInput label="Passsword" source="password" validate={[required()]} />}
    </RowForm>
);

const UsersFilters = [
    <TextInput source="id" label="User Id" />,
    <TextInput source="email" label="Email" />,
    <SelectInput label="Ruolo" source="roles" choices={[
        { id: 'admin', name: 'admin' },
        { id: 'candidato', name: 'candidato' },
        { id: 'collaboratore', name: 'collaboratore' }]} />
];




export const UsersCreate = (props) => {

    /*     const [create] = useCreate();
        const usersCreate = (data) => {
            create('users', { data });
        }; */

    return (
        <Create title={<>
            <Button>
                &nbsp;Crea Nuovo User
            </Button>
        </>} {...props}>
            <SimpleForm redirect="show">
                {<TextInput label="Email" source="email" validate={[required()]} />}
                {<PasswordInput label="Passsword" source="password" validate={[required()]} />}
                {<SelectInput label="Ruolo" source="roles" validate={[required()]} choices={[
                    { id: 'admin', name: 'admin' },
                    { id: 'candidato', name: 'candidato' },
                    { id: 'collaboratore', name: 'collaboratore' }]} />}
            </SimpleForm>
        </Create>
    );
}

/*  */

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

const PercentualeAvanzamento = ({ tblQuizId }) => {
    console.log(tblQuizId);
    const { data, loading, error } = useGetList('view-quiz-avanzamento', {
        filter: { tblQuizId: tblQuizId }
    });

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    // Verifica se data è definito e se ha almeno un elemento
    if (!data || data.length === 0) {
        return <p>No data available</p>;
    }

    return (
        <>
            <Typography variant="subtitle1" component="div">
                <strong>Percentuale Avanzamento </strong>
            </Typography>
            <LinearProgressWithLabel value={data[0].percent_avanzamento} />
        </>
    );
};

const GestioneTblQuizInShow = ({ id, ...props }) => {

    const record = useRecordContext();
    const { data, total, isLoading } = useGetList(
        'tbl-quiz',
        { filter: { usersId: record.id } }
    );
    if (!record) return null;


    return (<>{(total === 0)
        ? (
            (record.roles !== "candidato")
                ?
                <Card variant="outlined" sx={{
                    m: 8,
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: '#fff7e6', // Light orange background
                    '&:hover': {
                        boxShadow: 6,
                        backgroundColor: '#ffe4b3' // Darker orange on hover
                    }
                }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" component="div">
                                    <strong>Attenzione. Non sono previsti Quiz per user con ruolo admin e collaboratore.</strong>
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
                : <Card variant="outlined" sx={{
                    m: 8,
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: '#fff7e6', // Light orange background
                    '&:hover': {
                        boxShadow: 6,
                        backgroundColor: '#ffe4b3' // Darker orange on hover
                    }
                }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" component="div">
                                    <strong>Lista vuota vuota.</strong>
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <IconButton aria-label="create" sx={{ color: '#e85a2c' }}>
                                <ConfirmDialogCreateButtonCustom
                                    titolo={"Crea Quiz"}
                                    messaggio={"Sei sicuro di vole creare questo Quiz ?"}
                                    servizio={"tbl-quiz"} />
                            </IconButton>
                        </Box>
                    </CardContent>
                </Card>
        )

        : <Datagrid
            data={data}
            total={total}
            isLoading={isLoading}
            bulkActionButtons={false}
        >
            <Card variant="outlined" sx={{
                m: 1,
                borderRadius: 2,
                boxShadow: 3,
                backgroundColor: '#fff7e6', // Light orange background
                '&:hover': {
                    boxShadow: 6,
                    backgroundColor: '#ffe4b3' // Darker orange on hover
                }
            }}>
                <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle1" component="div">
                                <strong>Quiz Id:</strong> <TextField source="id"></TextField>
                            </Typography>
                            <Typography variant="subtitle1" component="div">
                                <strong>Data Creazione:</strong> <DateField source="createdAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>
                            </Typography>
                            <Grid container alignItems="center">
                                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="subtitle1" component="div">
                                        <strong>Data Scadenza:</strong> <DateField source="dataScadenza" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit' }} />
                                    </Typography>
                                </Grid>

                                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ marginRight: 1, transform: 'scale(0.8)' }}>
                                        <DialogDataScadenza />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Typography variant="subtitle1" component="div">
                                <strong>Descrizione:</strong> <TextField source="descrizione" variant="outlined" size="small" />
                            </Typography>
                            <Typography variant="subtitle1" component="div">
                                <strong>Stato:</strong> <TextField source="stato" variant="outlined" size="small" />
                            </Typography>
                            <FunctionField
                                source="id"
                                render={record => <PercentualeAvanzamento tblQuizId={record["id"]}></PercentualeAvanzamento>}
                            />
                            {/*  <Typography variant="subtitle1" component="div">
                                <strong>Attivo:</strong> <TextField source="flAttivo" variant="outlined" size="small" />
                            </Typography>
                            <Typography variant="subtitle1" component="div">
                                <strong>Visibile:</strong> <TextField source="flVisibile" variant="outlined" size="small" />
                            </Typography>
                            <Typography variant="subtitle1" component="div">
                                <strong>Annullato:</strong> <TextField source="flAnnullato" variant="outlined" size="small" />
                            </Typography> */}
                        </Box>
                    </Box>
                    <hr></hr>
                    <Box sx={{ backgroundColor: '#f0f0f0', padding: '10px', borderRadius: '4px' }}>
                        <IconButton aria-label="Calcola punteggio" sx={startActionButtonCss}>
                            <CalcolaButtonBox
                                titolo={"Calcola Punteggio Quiz"}
                                messaggio={"Sei sicuro di voler calcolare il punteggio del Quiz ?"}
                                servizio={"update-quiz-punteggio"} />
                        </IconButton>
                        <FunctionField
                            source="id"
                            label=""
                            render={record => <><GetUltimoCalcolo tblQuizId={record.id}></GetUltimoCalcolo></>}
                        />
                    </Box>
                    <hr></hr>
                    <Box sx={{ backgroundColor: '#f0f0f0', padding: '10px', borderRadius: '4px', marginTop: 2 }}>
                        <IconButton aria-label="create">
                            <ConfirmDialogSendButtonCustom
                                email={record.email}
                                titolo={"Invia dati d'accesso Quiz al Candidato"}
                                messaggio={"Sei sicuro di voler inviare i dati d'accesso al Candidato ?"}
                                servizio={"tbl-messaggi"} />
                        </IconButton>
                        <FunctionField
                            source="id"
                            label=""
                            render={record => <><GetUltimoInoltro tblQuizId={record.id}></GetUltimoInoltro></>}
                        />
                    </Box>
                    <hr></hr>

                    <Box>
                        <IconButton aria-label="delete" sx={{ color: '#e85a2c' }}>
                            <ConfirmDialogDeleteButtonCustom
                                titolo={"Cancella Quiz"}
                                messaggio={"Sei sicuro di voler cancellare questo Quiz ?"}
                                servizio={"tbl-quiz"} />
                        </IconButton>
                    </Box>
                </CardContent>
            </Card >

        </Datagrid >}</>);

}

const GestioneTblQuizGraficoInShow = ({ id, ...props }) => {

    const record = useRecordContext();
    const { data, total, isLoading } = useGetList(
        'tbl-quiz',
        { filter: { usersId: record.id } }
    );
    if (!record) return null;

    console.log(record);

    return (<>{(total === 0)
        ? (
            (record.roles !== "candidato")
                ?
                <Card variant="outlined" sx={{
                    m: 8,
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: '#fff7e6', // Light orange background
                    '&:hover': {
                        boxShadow: 6,
                        backgroundColor: '#ffe4b3' // Darker orange on hover
                    }
                }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" component="div">
                                    <strong>Attenzione. Non sono previsti Quiz per user con ruolo admin e collaboratore.</strong>
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
                : <Card variant="outlined" >
                    <CardContent>
                        -
                    </CardContent>
                </Card>
        )

        : <Datagrid
            data={data}
            total={total}
            isLoading={isLoading}
            bulkActionButtons={false}
        >

            {data && data.length > 0 ? (
                <GetGraficoQuiz tblQuizId={data[0].id}></GetGraficoQuiz>
            ) : (
                <div>Grafico - No data available</div>
            )}


        </Datagrid >}</>);

}

/*  */

export const UsersShow = (props) => {



    return (
        <Show title={<>
            <Button>
                &nbsp;Dettaglio User
            </Button>
            <FunctionField source="email" render={record => record && `${record.email}`} />
        </>} actions={null}>


            {/*                 <Grid item xs={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                </Box>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
            <Grid item xs={12}>
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <NoteIcon sx={iconStyle} />
                                Email : <FunctionField source="email" render={record => record && `${record.email}`} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                &nbsp;<h2><strong><FunctionField source="roles" render={record => record && `Ruolo: ${record.roles}`} /></strong></h2>
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <TabbedShowLayout>
                <TabbedShowLayout.Tab label="Dati User" sx={fieldTabForShow} icon={<NoteIcon sx={iconStyle} />}>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12}>
                            <Card sx={{ minWidth: 275 }}>
                                <CardContent>
                                    <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <NoteIcon />
                                            ID USER: <TextField label="Id User" source="id" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <NoteIcon />
                                            Ruolo: <TextField label="Ruolo" source="roles" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <EmailIcon />
                                            Email: <TextField label="Email" source="email" />
                                        </Box>
                                        {/*                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <HomeIcon />
                                            Ragione Sociale: <TextField label="Nome" source="nome" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                            <PersonIcon />
                                            Referente: <TextField label="Referente" source="referente" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <WorkIcon />
                                            Partita Iva: <TextField label="Partita Iva" source="partitaiva" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <PhoneIcon />
                                            Telefono: <TextField label="Telefono" source="telefono" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <PhoneIcon />
                                            Cellulare: <TextField label="Cellulare" source="cellulare" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <HomeIcon />
                                            Indirizzo: <TextField label="Indirizzo" source="indirizzo" />
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                            <NoteIcon />
                                            Note: <RichTextField label="Note" source="note" />
                                        </Box>
                                        */}

                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </TabbedShowLayout.Tab>
                {<TabbedShowLayout.Tab label="Quiz" sx={fieldTabForShow} icon={<QuizIcon sx={iconStyle} />}
                    count={<ReferenceManyCount
                        reference="tbl-quiz"
                        target="usersId" />}
                >
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <ReferenceManyField
                            reference="tbl-quiz"
                            target="usersId"
                            sort={{ field: 'id', order: 'ASC' }}
                        >
                            <Box sx={{ marginLeft: 2 }}>
                                <GestioneTblQuizInShow></GestioneTblQuizInShow>
                            </Box>
                        </ReferenceManyField>
                    </Grid>
                </TabbedShowLayout.Tab>}
                {<TabbedShowLayout.Tab label="Grafico" sx={fieldTabForShow} icon={<Leaderboard sx={iconStyle} />}

                >
                    <ReferenceManyField
                        reference="tbl-quiz"
                        target="usersId"
                        sort={{ field: 'id', order: 'ASC' }}
                    >
                        <GestioneTblQuizGraficoInShow></GestioneTblQuizGraficoInShow>
                    </ReferenceManyField>
                </TabbedShowLayout.Tab>}
            </TabbedShowLayout>
        </Show>
    );
}